var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCivilMatters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.666016,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#546FFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6933 19.3602C19.5933 19.4602 19.4667 19.5068 19.34 19.5068C19.2133 19.5068 19.0867 19.4602 18.9867 19.3602L15.6867 16.0602L16.04 15.7068L16.3933 15.3535L19.6933 18.6535C19.8867 18.8468 19.8867 19.1668 19.6933 19.3602Z",
    fill: "#546FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3133 12.8521L14.18 16.7188C14.44 16.9788 14.44 17.3988 14.18 17.6588L13.58 18.2654C13.04 18.7988 12.1867 18.7988 11.6533 18.2654L8.76001 15.3721C8.23334 14.8454 8.23334 13.9854 8.76001 13.4521L9.36667 12.8454C9.62667 12.5921 10.0533 12.5921 10.3133 12.8521Z",
    fill: "#546FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3933 13.4591L15.8533 15.9925C15.5867 16.2591 15.16 16.2591 14.8933 15.9925L11.04 12.1391C10.7733 11.8725 10.7733 11.4458 11.04 11.1791L13.58 8.63914C14.1067 8.11247 14.9667 8.11247 15.5 8.63914L18.3933 11.5325C18.92 12.0658 18.92 12.9191 18.3933 13.4591Z",
    fill: "#546FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 21.166H7.33333C7.05999 21.166 6.83333 20.9393 6.83333 20.666C6.83333 20.3927 7.05999 20.166 7.33333 20.166H11.3333C11.6067 20.166 11.8333 20.3927 11.8333 20.666C11.8333 20.9393 11.6067 21.166 11.3333 21.166Z",
    fill: "#546FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivilMatters);
export default __webpack_public_path__ + "static/media/civilMatters.725db0b631321002824fb77b5c6645bc.svg";
export { ForwardRef as ReactComponent };